import React from 'react';
import { inject, observer } from 'mobx-react';
import { InjectedProps } from '../../types';
import { AuditLogDashboard } from '../../features/audit-log/components/AuditLogDashboard';

export const AuditLogs = observer((props: InjectedProps) => <AuditLogDashboard store={props.store} />);

export default inject('store')(AuditLogs) as unknown as React.ComponentType;
